import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { CollaborationFormData, AccessRequestFormData } from "../../types/moderation/moderationTypes";
import { submitCollaborationRequest, submitAccessRequest } from "../../services/moderation/moderationApi";

interface ModerationState {
  submitting: boolean;
  successMessage: string | null;
  errorMessage: string | null;
  errorDetails: any | null; // ← اختیاری: برای نمایش جزئیات اعتبارسنجی فرم
}

const initialState: ModerationState = {
  submitting: false,
  successMessage: null,
  errorMessage: null,
  errorDetails: null,
};

// Collaboration Request ------------------------------------------------------
export const sendCollaborationRequest = createAsyncThunk(
  "moderation/sendCollaborationRequest",
  async (data: CollaborationFormData, { rejectWithValue }) => {
    try {
      const response = await submitCollaborationRequest(data);
      return response;
    } catch (error: any) {
      const errData = error.response?.data;
      return rejectWithValue({
        error: errData?.error || "Submission failed.",
        details: errData?.details || null,
      });
    }
  }
);

// Access Request ---------------------------------------------------------------
export const sendAccessRequest = createAsyncThunk(
  "moderation/sendAccessRequest",
  async (data: AccessRequestFormData, { rejectWithValue }) => {
    try {
      const res = await submitAccessRequest(data);
      return res;
    } catch (err: any) {
      const data = err.response?.data;

      return rejectWithValue({
        error: data?.error || data?.message || "Submission failed.",
        details: data?.details || null,
      });
    }
  }
);



const moderationSlice = createSlice({
  name: "moderation",
  initialState,
  reducers: {
    clearModerationState: (state) => {
      state.successMessage = null;
      state.errorMessage = null;
      state.errorDetails = null;
      state.submitting = false;
    },
  },
  extraReducers: (builder) => {
    builder

      // Collaboration Request --------------------------------------------------------------
      .addCase(sendCollaborationRequest.pending, (state) => {
        state.submitting = true;
        state.successMessage = null;
        state.errorMessage = null;
        state.errorDetails = null;
      })
      .addCase(sendCollaborationRequest.fulfilled, (state, action) => {
        state.submitting = false;
        state.successMessage = action.payload.message || "Submission successful.";
      })
      .addCase(sendCollaborationRequest.rejected, (state, action: any) => {
        state.submitting = false;
        state.errorMessage = action.payload?.error || "Something went wrong.";
        state.errorDetails = action.payload?.details || null;
      })

      // Access Request ---------------------------------------------------------------------
      .addCase(sendAccessRequest.pending, (state) => {
        state.submitting = true;
        state.successMessage = null;
        state.errorMessage = null;
        state.errorDetails = null;
      })
      .addCase(sendAccessRequest.fulfilled, (state, action) => {
        state.submitting = false;
        state.successMessage =
          action.payload?.message || "Your request has been submitted successfully!";
      })
      .addCase(sendAccessRequest.rejected, (state, action: any) => {
        state.submitting = false;
        state.errorMessage = action.payload?.error || "Something went wrong.";
        state.errorDetails = action.payload?.details || null;
      });



  },
});

export const { clearModerationState } = moderationSlice.actions;
export default moderationSlice.reducer;
